// NPM Imports
import React, { Fragment, useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Label, Input, Tooltip } from "@revvsales/components";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const SignerListSectionForm = ({
  fieldsUsed,
  signersList,
  addRemoveFiller,
  showMenu,
  handlePhoneNumber,
  toggleCheckbox,
  fillerMessgae,
}) => {
  const newFiller = [];
  fieldsUsed.forEach(element => {
    if (element.filler_type === "RECIPIENT") {
      newFiller.push(element);
    }
  });
  const roleDropdownRef = useRef(null);
  const [roles, setRole] = useState(
    signersList.map(sig => ({ ...sig, role: "Sign" })),
  );
  const [roleDropdownActive, setRoleDropdownActive] = useState(false);
  const [roleIndex, setRoleIndex] = useState(0);

  useEffect(
    () => {
      if (roleDropdownActive) {
        document.addEventListener("click", event => {
          if (!event.target.contains(roleDropdownRef.current)) {
            return;
          }
          setRoleDropdownActive(false);
        });
      } else {
        document.removeEventListener("click", () => {
          setRoleDropdownActive(false);
        });
      }
    },
    [roleDropdownActive],
  );

  const _handleRoleChange = (newRole, signer, index) => {
    if (newRole === "Sign") {
      addRemoveFiller(false, signer);
    } else {
      addRemoveFiller(true, signer);
    }

    setRole(
      roles.map((sig, i) => {
        if (index === i) {
          return {
            ...sig,
            role: newRole,
          };
        }
        return sig;
      }),
    );
    setRoleDropdownActive(false);
  };

  return signersList && signersList.length > 0 ? (
    <div>
      <div className="docsharingpopup-sharingform-title">
        <span className="docsharingpopup-sharingform-desc">
          These recipients will get an email with the document link where they
          can eSign.
        </span>
        <span className="docsharingpopup-sharingform-desc">
          You have assigned <strong>{`${newFiller.length} `}</strong> fields to
          recipients. Please give at lease one recipient, permission to{" "}
          <strong>fill the form</strong> in the document. Change Recipient
          Action to <strong>Fill and sign</strong>. Fillers will receive email
          with document link to <strong>fill the document</strong>.
        </span>
      </div>

      <div className="recipientlistsection-signerlist">
        <div className="recipientlistsection-signerlist-head">
          <div className="recipientlistsection-signerlist-head-1">
            Recipients who can sign this document
          </div>
          <div className="recipientlistsection-signerlist-head-2">
            Recipient action
          </div>
        </div>
        {signersList.map((signer, index) => (
          <div className="recipientlistsection-row-wrapper">
            <div className="recipientlistsection-row recipientlistsection-row-form esign-auth-head">
              <div className="col-md-9 docsharingpopup-sharedusers-col">
                <div className="documentrecipientlist-userprofile-wrapper">
                  <div className="documentrecipientlist-profileimage-wrapper">
                    {signer.image_url && (
                      <img alt="Revv" src={signer.image_url} />
                    )}
                  </div>
                  <div className="documentrecipientlist-profile-wrapper">
                    <span className="documentrecipientlist-profile-name">
                      {signer.first_name || signer.last_name
                        ? `${signer.first_name} ${signer.last_name}`
                        : "-"}
                    </span>
                    <span className="documentrecipientlist-profile-email">
                      {signer.user_email ? signer.user_email : "-"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-3 docsharingpopup-sharedusers-col">
                <span className="documentrecipientlist-role documentrecipient-user-cog">
                  <Tooltip
                    placement="top"
                    overlay="Enable SMS based eSign authentication for this recipient">
                    <FontAwesomeIcon
                      icon={["far", "user-cog"]}
                      className="documentrecipientlist-role-icon"
                    />
                  </Tooltip>
                </span>
                <span
                  className="sign-auth"
                  onClick={e => showMenu(e, index)}
                  onKeyPress={() => {}}
                  role="button"
                  tabIndex="0">
                  <i
                    className={`ic-dropdown ${
                      signer.showAuth ? "dropdown-open" : ""
                    }`}>
                    <FontAwesomeIcon
                      icon={["far", "angle-down"]}
                      className="documentrecipientlist-role-icon"
                    />
                  </i>
                </span>
              </div>
              <div className="documentrecipientlist-oauth-wrapper">
                {signer.showAuth && (
                  <Fragment>
                    <div className="documentrecipientlist-otp-wrapper">
                      <div className="documentrecipientlist-userprofile-wrapper">
                        <div className="documentrecipientlist-profile-wrapper">
                          <span className="documentrecipientlist-profile-name">
                            <span className="documentrecipientlist-profile-email">
                              Authentication
                              <span className="sign-auth esign-authen-icon">
                                <Tooltip
                                  placement="bottom"
                                  overlay="When recipient initiates eSign process, they will get an OTP via SMS for identity authentication"
                                  align={{
                                    offset: [6, 0],
                                  }}>
                                  <FontAwesomeIcon
                                    icon={["far", "info-circle"]}
                                    className="documentrecipientlist-role-icon"
                                  />
                                </Tooltip>
                              </span>
                            </span>
                          </span>

                          <span className="documentrecipientlist-profile-email esign-show-otp">
                            <Input
                              data-test="confirmationbox-template-delete-checkbox-input"
                              type="checkbox"
                              value=""
                              checked={signer.showOtp}
                              onChange={() => toggleCheckbox(index)}
                            />
                            <Tooltip
                              placement="bottom"
                              overlay="When recipient initiates eSign process, they will get an OTP via SMS for identity authentication"
                              align={{
                                offset: [6, 0],
                              }}>
                              <Label
                                className="esign-authen-icon"
                                htmlFor="documentdelete-checkbox"
                                data-test="esignotp-checkbox-label">
                                Send OTP by SMS
                              </Label>
                            </Tooltip>
                          </span>
                        </div>
                      </div>
                    </div>

                    {signer.showOtp && signer.showAuth && (
                      <Fragment>
                        <div className="documentrecipientlist-mobile-input-wrapper">
                          <PhoneInput
                            data-test="esign-phone-number"
                            international
                            countryCallingCodeEditable={false}
                            defaultCountry="US"
                            value={
                              signer.mobile_number ? signer.mobile_number : ""
                            }
                            autoFocus
                            onChange={e => handlePhoneNumber(e, index)}
                          />
                          {!signer.isPossible && (
                            <div className="esign-number-error">
                              Please enter a valid phone number of recipient.
                            </div>
                          )}
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </div>
            </div>
            <div className="recipientlistsection-action-dropdown">
              <div
                tabIndex="0"
                role="button"
                onKeyPress={() => {}}
                onClick={() => {
                  setRoleDropdownActive(!roleDropdownActive);
                  setRoleIndex(index);
                }}
                className="recipientlistsection-action-list-selected">
                {roles && roles[index].role}{" "}
                <FontAwesomeIcon
                  icon={["far", "angle-down"]}
                  className="recipientlistsection-action-angle-icon"
                />{" "}
              </div>
              {roleDropdownActive && roleIndex === index && (
                <div
                  ref={roleDropdownRef}
                  className="recipientlistsection-action-list">
                  <div
                    role="button"
                    tabIndex="0"
                    onKeyPress={() => {}}
                    onClick={() => {
                      _handleRoleChange("Fill & Sign", signer, index);
                    }}
                    className="recipientlistsection-action-list-item">
                    <FontAwesomeIcon
                      icon={["fas", "pen"]}
                      className="recipientlistsection-action-list-item-icon"
                    />{" "}
                    Fill & Sign
                    <div className="recipientlistsection-action-list-item-sub-text">
                      Allow recipient to fill and sign
                    </div>
                  </div>
                  <div
                    role="button"
                    tabIndex="0"
                    onKeyPress={() => {}}
                    onClick={() => {
                      _handleRoleChange("Sign", signer, index);
                    }}
                    className="recipientlistsection-action-list-item">
                    <FontAwesomeIcon
                      icon={["fas", "signature"]}
                      className="recipientlistsection-action-list-item-icon"
                    />
                    Sign
                    <div className="recipientlistsection-action-list-item-sub-text">
                      Allow recipient to sign only
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
        {newFiller && newFiller.length > 0 && fillerMessgae ? (
          <div className="recipientlistsection-signerlist-head">
            <div
              className="requiredwitherr-icon"
              data-test="errormessages-requiredwitherr-icon">
              <div style={{ marginTop: "1px" }}>
                <FontAwesomeIcon icon={["far", "exclamation-triangle"]} />
              </div>
              <div style={{ marginLeft: "10px" }}>
                You have assigned fields to recipients for filling. Please give
                fill and sign permission to at least once recipient.
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  ) : null;
};

export default SignerListSectionForm;



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/AddRecipientsPopup/SignerListSectionForm.js